import React, { Component } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { TranslateExt } from "../contexts/LanguageContext";

const period = [
    { title: 'Daily', key: 'daily' },
    { title: 'Weekly', key: 'weekly' },
    { title: 'Monthly', key: 'monthly' },
    { divider: true },
    { title: 'All of Time', key: 'all' },
]

export class HistoryPeriod extends Component {

    constructor(props) {
        super(props)

        let period = localStorage.getItem("period");

        this.state = {
            active: (period ? period : "daily")
        }
    }
    onChange(key) {

        this.setState({
            active: key
        }, () => {
            this.props.onChange(key);
            localStorage.setItem("period", key);
        });
    }
    render() {
        return (
            <div className="btn-group mo-mb-2">
                <Dropdown isOpen={this.state.drp_small_btn} toggle={() => this.setState({ drp_small_btn: !this.state.drp_small_btn })}>
                    <DropdownToggle className="btn btn-secondary btn-sm" caret><i className="far fa-calendar"></i> &nbsp; {TranslateExt('History Period Filter')} &nbsp;</DropdownToggle>
                    <DropdownMenu>
                        {period.map(item => (
                            item.divider ?
                                <DropdownItem key="divider" divider />
                                :
                                <DropdownItem key={item.key} className={this.state.active === item.key ? "active" : ""} onClick={(e) => this.onChange(item.key)}>{TranslateExt(item.title)}</DropdownItem>
                        ))}
                    </DropdownMenu>
                </Dropdown>
            </div>)
    }

}